import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import Loading from "./Loading";

const OnboardingRoute = ({ children }) => {
  const { user, checkingUser, profileComplete } = useAuth();
  const location = useLocation();

  // ✅ extrai o ?lang= da URL ou usa 'en' como fallback
  const searchParams = new URLSearchParams(location.search);
  const locale = searchParams.get("lang") || "en";

  // ✅ exibe loader enquanto o status de login está sendo verificado
  if (checkingUser) return <Loading locale={locale} />;

  // ✅ redireciona se não estiver logado
  if (!user) return <Navigate to="/" replace />;

  // ✅ redireciona se o perfil já estiver completo
  if (profileComplete) return <Navigate to="/dashboard" replace />;

  // ✅ renderiza conteúdo normalmente
  return children;
};

export default OnboardingRoute;
